import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addReview } from '../add-review';
import { ReviewsQueryKey, ReviewRatingsQueryKey } from './keys';

export function useAddReviewMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addReview,
    onSuccess: async (response, variables) => {
      // Инвалидируем все кеши отзывов для данной ноты (все страницы)
      await queryClient.invalidateQueries({
        queryKey: [ReviewsQueryKey, variables.noteId],
      });

      // Также инвалидируем общий кеш отзывов
      await queryClient.invalidateQueries({
        queryKey: [ReviewsQueryKey],
      });

      // Инвалидируем кеш статистики рейтингов
      await queryClient.invalidateQueries({
        queryKey: [ReviewRatingsQueryKey, variables.noteId],
      });

      // Триггерим реваалидацию серверного кеша по тегам отзывов и рейтингов (через GET)
      try {
        const params = new URLSearchParams({ noteId: String(variables.noteId) });
        await fetch(`/api-v2/revalidate-reviews?${params.toString()}`, { method: 'GET' });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Не удалось реваалидировать серверный кеш отзывов/рейтингов:', e);
      }

      // Опционально: показываем уведомление об успехе
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Отзыв успешно добавлен, кеш обновлен:', {
          noteId: variables.noteId,
          reviewText: variables.text,
          rating: variables.rating,
          reviewId: response.data.review_id,
          response,
        });
      }
    },
    onError: (error, variables) => {
      // Логируем ошибку мутации
      console.error('Ошибка добавления отзыва:', {
        noteId: variables.noteId,
        reviewText: variables.text,
        authorName: variables.name,
        rating: variables.rating,
        error: error instanceof Error ? error.message : String(error),
      });

      // Отправляем ошибку в систему логирования
      if (typeof window !== 'undefined') {
        try {
          void fetch('/api-v2/send-log', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              level: 3,
              msg: JSON.stringify({
                error: 'Ошибка добавления отзыва о товаре',
                noteId: variables.noteId,
                reviewText: variables.text,
                authorName: variables.name,
                rating: variables.rating,
                details: error instanceof Error ? error.message : String(error),
              }),
              href: window.location.href,
              titlePage: document?.title,
              userAgent: navigator?.userAgent,
            }),
          });
        } catch (logError) {
          console.error('Ошибка отправки лога о мутации:', logError);
        }
      }
    },
  });
} 